"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var graphQLConfig = {
    props: function (props) { return props; },
    options: function (props) {
        return {
            variables: {
                slug: props.params.slug,
            },
            ssr: false,
        };
    },
};
var ARTICLE_QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query Commons_MParticle_Article(\n    $slug: String\n  )\n  {\n    article(input: { slug: $slug } ) {\n      categories {\n        slug\n      }\n    }\n  }\n"], ["\n  query Commons_MParticle_Article(\n    $slug: String\n  )\n  {\n    article(input: { slug: $slug } ) {\n      categories {\n        slug\n      }\n    }\n  }\n"])));
function trackMParticleArticlePageView(props) {
    var article = props.data.article;
    if (article) {
        var transformedArticleSlugs = article.categories.map(function (article) { return article.slug; }).join('|');
        mparticle_tracker_1.trackPageView({
            pageName: mparticle_tracker_1.MParticlePageName.News,
            articleSlug: props.params.slug,
            articleCategories: transformedArticleSlugs,
        });
    }
    return null;
}
exports.trackMParticleArticlePageView = trackMParticleArticlePageView;
exports.default = react_apollo_1.graphql(ARTICLE_QUERY, graphQLConfig)(trackMParticleArticlePageView);
var templateObject_1;
//# sourceMappingURL=track_article_page_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/track_article_page_view.js
// module id = q3E8
// module chunks = 20 21